/**
 * Get Authorization header for API calls to ecom-backend-middleware.
 * Uses ping_access_token from localStorage (set after Ping login).
 */

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = localStorage.getItem('ping_access_token');
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
}
